import React, { useState, useRef, useEffect } from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import {
  LayoutDashboard, Users, UserCog, ClipboardList, Activity, Pill, PillBottle, CalendarDays,
  Sparkles, Building2, LogOut as LogOutIcon, Receipt, Zap, Wallet, Utensils,
  BarChart3, Bell, FileText, Settings, ShieldCheck, Home, ChevronDown, UserCircle, CalendarRange, Package, Droplets, ShieldAlert, HeartPulse, TriangleAlert, UtensilsCrossed, Phone, MessageSquareWarning, Inbox, FolderOpen, Clock, Megaphone, ClipboardCheck, PiggyBank, BedDouble, UserPlus, MessageSquare, ArrowRightLeft, CalendarClock, Menu, X, PanelLeft, ArrowUpCircle, CupSoda, Salad, GripVertical, ArrowUpDown, Check, RefreshCw, StickyNote, Truck, Calculator, BookOpen, Mail, TrendingDown, Landmark, Percent, CircleAlert, ShoppingCart, Table2, CalendarCheck, ListChecks, Database, PenLine, Stethoscope, Syringe,
} from "lucide-react";
import { DndContext, closestCenter, PointerSensor, TouchSensor, useSensor, useSensors } from "@dnd-kit/core";
import { SortableContext, useSortable, verticalListSortingStrategy, arrayMove } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { useAuth } from "../context/AuthContext";
import { OspiteFocus } from "./OspiteFocus";
import { useFirma, shortName } from "../context/FirmaContext";
import { IdleBar } from "../context/FirmaContext";
import { useQuery } from "@tanstack/react-query";
import api from "../lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import HelpButton from "./HelpButton";
import NewsPopup from "./NewsPopup";
import SollecitoPopup from "./SollecitoPopup";
import FineTurnoPopup from "./FineTurnoPopup";
import { useCfgSanitarie } from "../lib/cfgSanitarie";
import { StoricoModificheBtn } from "./StoricoModifiche";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, DropdownMenuLabel, DropdownMenuSeparator,
} from "./ui/dropdown-menu";

const MENU = [
  { group: "Area Supervisore", items: [
    { to: "/segnalazioni", label: "Segnalazioni", icon: CircleAlert, section: "supervisor_ospiti" },
  ]},
  { group: "Area tecnica", items: [
    { to: "/note", label: "Note", icon: StickyNote, section: "dashboard", always: true },
    { to: "/guida", label: "Guida", icon: BookOpen, section: "dashboard", always: true },
    { to: "/turni", label: "Turni", icon: CalendarDays, section: "turni" },
    { to: "/riunioni", label: "Riunioni", icon: CalendarDays, section: "riunioni" },
    { to: "/piano-lavoro", label: "Piano di Lavoro OSS", icon: ClipboardCheck, section: "piano_lavoro" },
    { to: "/prese-visione", label: "Prese visione", icon: ClipboardCheck, section: "attivita" },
    { to: "/news", label: "News e Task", icon: Megaphone, section: "news" },
    { to: "/numeri-utili", label: "Numeri utili", icon: Phone, section: "numeri_utili" },
  ]},
  { group: "Area Cucina", items: [
    { to: "/menu", label: "Cucina", icon: UtensilsCrossed, section: "menu" },
    { to: "/menu-pasti", label: "Menu & Pasti", icon: Salad, section: "menu", testid: "menu-pasti" },
    { to: "/programma-spesa", label: "Programma Spesa", icon: ShoppingCart, section: "menu", testid: "programma-spesa" },
  ]},
  { group: "Area operativa", items: [
    { to: "/mio-account", label: "Il mio account", icon: UserCircle, section: "dashboard", always: true },
    { to: "/", label: "Dashboard", icon: LayoutDashboard, section: "dashboard" },
    { to: "/supervisor-ospiti", label: "Report del giorno", icon: Users, section: "supervisor_ospiti", always: true, bold: true },
    { to: "/supervisor-richiami", label: "Report operatori", icon: TriangleAlert, section: "supervisor_richiami" },
    { to: "/presenze", label: "Presenze", icon: Clock, section: "presenze" },
    { to: "/consegne", label: "Consegne", icon: ClipboardList, section: "consegne" },
    { to: "/registro-firme", label: "Registro firme", icon: PenLine, section: "consegne" },
    { to: "/movimenti", label: "Entrate / Uscite", icon: ArrowRightLeft, section: "ospiti" },
    { to: "/ospiti", label: "Ospiti", icon: Users, section: "ospiti" },
    { to: "/alvo", label: "Alvo intestinale", icon: Activity, section: "alvo" },
    { to: "/alzate", label: "Alzate", icon: ArrowUpCircle, section: "alzate" },
    { to: "/messa-a-letto", label: "Messa a letto", icon: BedDouble, section: "messa_a_letto" },
    { to: "/terapie", label: "Terapie", icon: Pill, section: "terapie" },
    { to: "/controllo-terapie", label: "Controllo terapie", icon: PillBottle, section: "controllo_terapie" },
    { to: "/non-mangia", label: "Non mangia", icon: Salad, section: "non_mangia" },
    { to: "/non-beve", label: "Non beve", icon: CupSoda, section: "non_beve" },
    { to: "/pulizie", label: "Pulizie", icon: Sparkles, section: "pulizie" },
    { to: "/pannoloni", label: "Pannoloni e presidi", icon: Package, section: "pannoloni" },
    { to: "/docce", label: "Docce", icon: Droplets, section: "docce" },
    { to: "/infettive", label: "Eventi sanitari", icon: ShieldAlert, section: "infettive" },
    { to: "/check-list-sanitaria", label: "Check-list sanitaria", icon: ListChecks, section: "infettive", testid: "check-list-sanitaria" },
    { to: "/cartella-clinica", label: "Visite mediche", icon: Stethoscope, section: "visite_mediche", testid: "visite-mediche" },
    { to: "/impostazione-terapie", label: "Impostazione terapie", icon: Syringe, section: "impostazione_terapie", testid: "impostazione-terapie" },
    { to: "/parametri", label: "Parametri vitali", icon: HeartPulse, section: "parametri" },
    { to: "/cadute", label: "Cadute e infortuni", icon: TriangleAlert, section: "cadute" },
  ]},
  { group: "Area operatori", items: [
    { to: "/check-in-operatore", label: "Check in operatori", icon: UserPlus, section: "operatori" },
    { to: "/operatori", label: "Operatori", icon: UserCog, section: "operatori" },
    { to: "/utenti", label: "Utenti e permessi", icon: ShieldCheck, section: "utenti" },
    { to: "/attivita", label: "Attività operatori", icon: Activity, section: "attivita" },
    { to: "/impostazioni", label: "Impostazioni", icon: Settings, section: "impostazioni", testid: "impostazioni" },
    { to: "/email-massiva", label: "Email massiva", icon: Mail, section: "email_massiva", testid: "email-massiva" },
  ]},
  { group: "Area Ingressi", items: [
    { to: "/check-in", label: "Check-in Ospite", icon: UserPlus, section: "checkin" },
    { to: "/ingressi-contatti", label: "Nuovi Contatti", icon: Inbox, section: "ingressi_contatti" },
    { to: "/ingressi-report", label: "Report Ammissioni", icon: BarChart3, section: "ingressi_report" },
    { to: "/ingressi-registro", label: "Registro", icon: ClipboardList, section: "ingressi_registro" },
    { to: "/prenotazioni", label: "Prenotazioni / Caparre", icon: CalendarCheck, section: "prenotazioni" },
  ]},
  { group: "Amministrazione", items: [
    { to: "/dashboard-amministrativa", label: "Dashboard amministrativa", icon: LayoutDashboard, section: "controllo", testid: "dashboard-amministrativa" },
    { to: "/controllo", label: "Ricavi - Costi", icon: BarChart3, section: "controllo" },
    { to: "/rette", label: "Ricavi e rette", icon: Receipt, section: "rette" },
    { to: "/previsioni", label: "Previsioni", icon: Calculator, section: "controllo", testid: "previsioni" },
    { to: "/spese", label: "Spese", icon: Wallet, section: "spese", testid: "spese" },
    { to: "/fornitori", label: "Fornitori", icon: Truck, section: "spese", testid: "fornitori" },
    { to: "/buste_paga", label: "Buste paga", icon: FileText, section: "buste_paga" },
    { to: "/tfr-f24", label: "TFR e F24", icon: PiggyBank, section: "buste_paga", testid: "tfr_f24" },
    { to: "/f24-mensili", label: "F24 mensili", icon: CalendarClock, section: "buste_paga", testid: "f24_mensili" },
    { to: "/finanziario", label: "Mutui", icon: Landmark, section: "finanziario", testid: "finanziario" },
    { to: "/ammortamenti", label: "Ammortamenti", icon: TrendingDown, section: "finanziario", testid: "ammortamenti" },
    { to: "/tasse", label: "Risultati & Tasse", icon: Percent, section: "controllo", testid: "tasse" },
    { to: "/banche", label: "Banche", icon: Building2, section: "controllo", testid: "banche" },
    { to: "/excel", label: "Excel", icon: Table2, section: "controllo", testid: "excel" },
    { to: "/documenti-amministrazione", label: "Documenti", icon: FolderOpen, section: "doc_admin" },
    { to: "/come-funziona", label: "Come funziona", icon: BookOpen, section: "doc_admin", testid: "come-funziona" },
  ]},
  { group: "Extra", items: [
    { to: "/extra", label: "Extra", icon: Wallet, section: "extra", testid: "extra" },
    { to: "/extra-dashboard", label: "Dashboard", icon: LayoutDashboard, section: "extra", testid: "extra-dashboard" },
  ]},
  { group: "Configurazione", items: [
    { to: "/strutture", label: "Strutture", icon: Home, section: "strutture" },
    { to: "/documenti", label: "Documenti e scadenze", icon: FileText, section: "documenti" },
    { to: "/notifiche", label: "Notifiche", icon: Bell, section: "notifiche" },
    { to: "/admin", label: "Aziende & Piani", icon: Building2, section: "adminconsole" },
    { to: "/audit", label: "Audit log", icon: Settings, section: "audit" },
    { to: "/database", label: "Database", icon: Database, section: "database" },
    { to: "/privacy-gdpr", label: "Privacy / GDPR", icon: ShieldCheck, section: "database" },
  ]},
];

// Colorazione icone del menu (leggibili sul verde scuro --gr-sidebar)
// Area operativa: tutte verdi, tranne 4 rosse (Eventi sanitari, Check-list sanitaria, Parametri vitali, Cadute)
const OP_ICON_COLOR = {
  "/infettive": "#f87171", "/check-list-sanitaria": "#f87171", "/cartella-clinica": "#2dd4bf", "/impostazione-terapie": "#a78bfa", "/parametri": "#f87171", "/cadute": "#f87171",
};
// Un colore unico per ciascuna altra area
const AREA_COLOR = {
  "Area Supervisore": "#fb923c",   // arancio
  "Area tecnica": "#a78bfa",       // viola
  "Area Cucina": "#fbbf24",        // ambra
  "Area operatori": "#2dd4bf",     // teal
  "Area Ingressi": "#818cf8",      // indaco
  "Amministrazione": "#fcd34d",    // oro
  "Extra": "#f472b6",              // rosa
  "Configurazione": "#38bdf8",     // azzurro
};
const iconColor = (it, group) => {
  if (group === "Area operativa") return OP_ICON_COLOR[it.to] || "#4ade80"; // verde di default
  return AREA_COLOR[group] || "#9fb7ad";
};


function SortableNavItem({ it, group }) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: it.to });
  const style = { transform: CSS.Transform.toString(transform), transition, opacity: isDragging ? 0.5 : 1 };
  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}
      data-testid={`nav-reorder-${it.testid || it.section}`}
      className="gr-sidebar-link flex items-center gap-2 cursor-grab active:cursor-grabbing select-none touch-none bg-white/5 border border-dashed border-white/15 rounded-lg my-0.5">
      <GripVertical size={16} className="text-white/50 shrink-0" />
      <it.icon size={18} style={{ color: iconColor(it, group) }} /> <span className="truncate">{it.label}</span>
    </div>
  );
}

export default function Layout({ children }) {
  const { user, structures, selectedStructure, setSelectedStructure, logout, can, companyLogo, opSections = [] } = useAuth();
  const [mobileOpen, setMobileOpen] = useState(false);
  useCfgSanitarie();
  const [collapsed, setCollapsed] = useState(() => localStorage.getItem("gr_sidebar_collapsed") === "1");
  useEffect(() => { localStorage.setItem("gr_sidebar_collapsed", collapsed ? "1" : "0"); }, [collapsed]);
  const [reorder, setReorder] = useState(false);
  const [navOrder, setNavOrder] = useState({});
  useEffect(() => { if (user && user.nav_order) setNavOrder(user.nav_order); }, [user]);
  const sensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 6 } }),
    useSensor(TouchSensor, { activationConstraint: { delay: 200, tolerance: 8 } }),
  );
  const orderItems = (grp, visible) => {
    const pinFirst = (list) => {
      if (grp.group !== "Area operativa") return list;
      const idx = list.findIndex((it) => it.to === "/mio-account");
      if (idx <= 0) return list;
      const copy = [...list];
      const [mio] = copy.splice(idx, 1);
      return [mio, ...copy];
    };
    const saved = (navOrder[grp.group] || []).map((to) => (to === "/visite-mediche" ? "/cartella-clinica" : to));
    if (!saved.length) return pinFirst(visible);
    const byTo = Object.fromEntries(visible.map((it) => [it.to, it]));
    const ordered = saved.map((to) => byTo[to]).filter(Boolean);
    const rest = visible.filter((it) => !saved.includes(it.to));
    return pinFirst([...ordered, ...rest]);
  };
  const persistOrder = async (next) => { setNavOrder(next); try { await api.put("/me/nav-order", { nav_order: next }); } catch (e) { /* ignore */ } };
  const handleDragEnd = (grpName, items) => (e) => {
    const { active, over } = e;
    if (!over || active.id === over.id) return;
    const ids = items.map((it) => it.to);
    const newIds = arrayMove(ids, ids.indexOf(active.id), ids.indexOf(over.id));
    persistOrder({ ...navOrder, [grpName]: newIds });
  };
  const { firmaEnabled, activeOperatore, change, identity } = useFirma();
  const isOperator = !!user && !["admin", "super_admin"].includes(user.role);
  const orderedMenu = React.useMemo(() => {
    if (!isOperator) return MENU;
    const op = MENU.filter((g) => g.group === "Area operativa");
    const rest = MENU.filter((g) => g.group !== "Area operativa");
    return [...op, ...rest];
  }, [isOperator]);
  const nav = useNavigate();
  const location = useLocation();
  const { data: notifs = [] } = useQuery({
    queryKey: ["notif-count", selectedStructure],
    enabled: !!user && can("notifiche"),
    refetchInterval: 30000,
    queryFn: async () => (await api.get("/notifiche", { params: selectedStructure && selectedStructure !== "all" ? { structure_id: selectedStructure } : {} })).data,
  });
  const unread = notifs.filter((n) => !n.read).length;
  const _bellMese = new Date().toISOString().slice(0, 7);
  const _bellDa = `${_bellMese}-01`;
  const _bellA = `${_bellMese}-${String(new Date(Number(_bellMese.slice(0, 4)), Number(_bellMese.slice(5, 7)), 0).getDate()).padStart(2, "0")}`;
  const canSupR = can("supervisor_richiami");
  const { data: supRich } = useQuery({
    queryKey: ["bell-sup-richiami", selectedStructure, _bellMese],
    enabled: !!user && canSupR, refetchInterval: 300000, staleTime: 300000, retry: false,
    queryFn: async () => (await api.get("/supervisor/richiami", { params: { structure_id: selectedStructure, da: _bellDa, a: _bellA } })).data,
  });
  const { data: myRich } = useQuery({
    queryKey: ["bell-my-richiami", identity?.operatore_id, _bellMese],
    enabled: !!user && !canSupR && !!identity?.operatore_id, refetchInterval: 180000, staleTime: 120000, retry: false,
    queryFn: async () => (await api.get("/firma/mio-account/richiami", { params: { op_id: identity.operatore_id, da: _bellDa, a: _bellA } })).data,
  });
  const richiamiDaLeggere = canSupR
    ? (supRich?.operatori || []).filter((o) => (o.giorni_distinti - o.pv_giorni) > 0).length
    : (myRich ? Math.max(0, (myRich.giorni_distinti || 0) - (myRich.pv_giorni || 0)) : 0);
  const bellTotal = unread + richiamiDaLeggere;
  const bellDest = richiamiDaLeggere > 0 ? (canSupR ? "/supervisor-richiami" : "/mio-account") : "/notifiche";
  const bellTitle = `${unread} notifiche non lette${richiamiDaLeggere ? ` · ${richiamiDaLeggere} ${canSupR ? "operatori con report da confermare" : "report da leggere"}` : ""}`;
  const GRAVE = ["parametri", "infettive", "cadute"];
  const TICKET = ["lamentele", "richieste"];
  const { data: newsOggi = [] } = useQuery({
    queryKey: ["news-oggi-badge", selectedStructure],
    enabled: !!user && can("news"),
    refetchInterval: 60000,
    queryFn: async () => (await api.get("/news/oggi", { params: selectedStructure && selectedStructure !== "all" ? { structure_id: selectedStructure } : {} })).data,
  });
  const _td = new Date();
  const todayIso = `${_td.getFullYear()}-${String(_td.getMonth() + 1).padStart(2, "0")}-${String(_td.getDate()).padStart(2, "0")}`;
  const opId = identity?.operatore_id;
  const newsUnread = newsOggi.filter((n) => !(n.letture || []).some((l) => l.operatore_id === opId && l.data === todayIso)).length;
  const { data: consegneBadge = [] } = useQuery({
    queryKey: ["consegne-badge", selectedStructure],
    enabled: !!user && can("consegne"),
    queryFn: async () => { try { return (await api.get("/consegne", { params: { structure_id: selectedStructure } })).data; } catch { return []; } },
    refetchInterval: 30000,
  });
  const consegneUnread = consegneBadge.filter((c) => c.data === todayIso && !(c.letture || []).some((l) => l.user_id === user?.id)).length;
  const { data: badges = {} } = useQuery({
    queryKey: ["nav-badges", selectedStructure],
    enabled: !!user,
    refetchInterval: 60000,
    queryFn: async () => (await api.get("/dashboard/badges", { params: selectedStructure && selectedStructure !== "all" ? { structure_id: selectedStructure } : {} })).data,
  });
  const { data: reportDaCompletare = 0 } = useQuery({
    queryKey: ["nav-report-da-completare", selectedStructure, todayIso],
    enabled: !!user,
    retry: false,
    refetchInterval: 120000,
    queryFn: async () => (await api.get("/supervisor/ospiti/da-completare", { params: { data: todayIso, ...(selectedStructure && selectedStructure !== "all" ? { structure_id: selectedStructure } : {}) } })).data.tot_mancante || 0,
  });
  const clOverdue = badges.checklist_sanitaria || 0;
  const bellTotal2 = bellTotal + clOverdue;
  const bellDest2 = clOverdue > 0 && richiamiDaLeggere === 0 && unread === 0 ? "/check-list-sanitaria" : bellDest;
  const bellTitle2 = clOverdue > 0 ? `${bellTitle}${bellTitle ? " · " : ""}${clOverdue} check-list obbligatorie in ritardo` : bellTitle;
  const _opq = identity?.operatore_id ? { op_id: identity.operatore_id, op_name: identity.operatore_nome } : {};
  const { data: chatUnreadData = { count: 0 } } = useQuery({
    queryKey: ["chat-unread", selectedStructure, identity?.operatore_id],
    enabled: !!user && can("comunicazioni"),
    refetchInterval: 15000,
    queryFn: async () => { try { return (await api.get("/chat/unread", { params: _opq })).data; } catch { return { count: 0 }; } },
  });
  const chatUnread = chatUnreadData.count || 0;

  // Notifica sonora: campanello all'aumentare dei messaggi chat non letti
  const prevChatUnread = useRef(null);
  const audioCtxRef = useRef(null);
  useEffect(() => {
    if (prevChatUnread.current === null) { prevChatUnread.current = chatUnread; return; }
    if (chatUnread > prevChatUnread.current) {
      try {
        if (!audioCtxRef.current) audioCtxRef.current = new (window.AudioContext || window.webkitAudioContext)();
        const ctx = audioCtxRef.current;
        if (ctx.state === "suspended") ctx.resume();
        const t0 = ctx.currentTime;
        [880, 1320].forEach((freq, i) => {
          const o = ctx.createOscillator(); const g = ctx.createGain();
          o.type = "sine"; o.frequency.value = freq;
          o.connect(g); g.connect(ctx.destination);
          const t = t0 + i * 0.15;
          g.gain.setValueAtTime(0.0001, t);
          g.gain.exponentialRampToValueAtTime(0.25, t + 0.02);
          g.gain.exponentialRampToValueAtTime(0.0001, t + 0.35);
          o.start(t); o.stop(t + 0.4);
        });
      } catch (e) { /* audio non disponibile */ }
    }
    prevChatUnread.current = chatUnread;
  }, [chatUnread]);

  return (
    <div className="flex h-[100dvh] overflow-hidden">
      {mobileOpen && <div className="fixed inset-0 bg-black/40 z-40 md:hidden" onClick={() => setMobileOpen(false)} data-testid="sidebar-overlay" />}
      <aside className={`w-64 shrink-0 flex flex-col h-[100dvh] fixed top-0 left-0 z-50 transition-all duration-200 md:sticky md:top-0 ${mobileOpen ? "translate-x-0" : "-translate-x-full"} ${collapsed ? "md:w-0 md:-translate-x-full md:overflow-hidden" : "md:w-64 md:translate-x-0"}`} style={{ background: "var(--gr-sidebar)" }}>
        <div className="px-5 py-5 flex items-center gap-3 border-b border-white/10">
          {companyLogo
            ? <img src={companyLogo} alt="Logo azienda" data-testid="sidebar-logo" className="h-10 w-10 rounded-xl object-contain bg-white p-0.5" />
            : <div className="h-10 w-10 rounded-xl grid place-items-center text-white font-bold" style={{ background: "var(--gr-primary)" }}>GR</div>}
          <div>
            <div className="text-white font-head font-bold leading-tight">Gestione</div>
            <div className="text-[#9db8ac] text-xs font-semibold">Residenze</div>
          </div>
          <button onClick={() => { setMobileOpen(false); setCollapsed(true); }} className="ml-auto text-white/70 hover:text-white p-1" data-testid="sidebar-close" aria-label="Chiudi menu"><X size={22} /></button>
        </div>
        <nav className="flex-1 min-h-0 overflow-y-auto overscroll-contain px-3 pb-6">
          <div className="flex items-center gap-2 py-2 mb-1">
            <button onClick={() => setReorder((r) => !r)} data-testid="nav-reorder-toggle"
              className="flex-1 text-xs font-semibold text-white/70 hover:text-white flex items-center justify-center gap-1.5 py-1.5 rounded-lg border border-white/10 hover:bg-white/5 transition-colors">
              {reorder ? <><Check size={14} /> Fine</> : <><ArrowUpDown size={14} /> Personalizza ordine</>}
            </button>
            {reorder && <button onClick={() => persistOrder({})} data-testid="nav-reorder-reset"
              className="text-xs font-semibold text-white/60 hover:text-white px-2 py-1.5 rounded-lg border border-white/10 hover:bg-white/5 transition-colors">Ripristina</button>}
          </div>
          {reorder && <div className="text-[11px] text-white/50 px-1 mb-2 leading-snug">Trascina le voci per riordinarle. Puoi spostarle solo all'interno della stessa area.</div>}
          {orderedMenu.map((grp) => {
            const permOk = (s) => (activeOperatore ? opSections.includes(s) : can(s));
            const visible = orderItems(grp, grp.items.filter((it) => it.always || permOk(it.section)));
            if (!visible.length) return null;
            return (
              <div key={grp.group}>
                <div className="gr-sidebar-section">{grp.group}</div>
                {reorder ? (
                  <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd(grp.group, visible)}>
                    <SortableContext items={visible.map((v) => v.to)} strategy={verticalListSortingStrategy}>
                      {visible.map((it) => <SortableNavItem key={it.to} it={it} group={grp.group} />)}
                    </SortableContext>
                  </DndContext>
                ) : visible.map((it) => (
                  <NavLink key={it.to} to={it.to} end={it.to === "/"} onClick={() => setMobileOpen(false)}
                    data-testid={`nav-${it.testid || it.section}`}
                    className={({ isActive }) => `gr-sidebar-link flex items-center gap-2 ${isActive ? "active" : ""}`}>
                    <it.icon size={18} style={{ color: iconColor(it, grp.group) }} /> <span className={it.bold ? "font-extrabold text-white" : ""} data-testid={it.bold ? "nav-label-report-giorno" : undefined}>{it.label}</span>
                    {GRAVE.includes(it.section) && it.to !== "/check-list-sanitaria" && it.to !== "/cartella-clinica" && it.to !== "/impostazione-terapie" && badges[it.section] > 0 && <span data-testid={`nav-badge-${it.section}`} className="ml-auto min-w-[18px] h-[18px] px-1 rounded-full bg-red-500 text-white text-[10px] font-bold grid place-items-center">{badges[it.section] > 99 ? "99+" : badges[it.section]}</span>}
                    {it.to === "/supervisor-ospiti" && reportDaCompletare > 0 && <span data-testid="nav-badge-report-giorno" title="Cose ancora da completare oggi" className="ml-auto min-w-[18px] h-[18px] px-1 rounded-full bg-orange-500 text-white text-[10px] font-bold grid place-items-center">{reportDaCompletare > 99 ? "99+" : reportDaCompletare}</span>}
                    {it.to === "/check-list-sanitaria" && badges.checklist_sanitaria > 0 && <span data-testid="nav-badge-checklist-sanitaria" title="Controlli obbligatori in ritardo" className="ml-auto min-w-[18px] h-[18px] px-1 rounded-full bg-red-500 text-white text-[10px] font-bold grid place-items-center">{badges.checklist_sanitaria > 99 ? "99+" : badges.checklist_sanitaria}</span>}
                    {TICKET.includes(it.section) && badges[it.section] > 0 && <span data-testid={`nav-badge-${it.section}`} title="Ticket in attesa di una tua risposta" className="ml-auto min-w-[18px] h-[18px] px-1 rounded-full bg-blue-500 text-white text-[10px] font-bold grid place-items-center">{badges[it.section] > 99 ? "99+" : badges[it.section]}</span>}
                    {it.section === "news" && newsUnread > 0 && <span data-testid="nav-badge-news" title="Compiti/task non ancora letti" className="ml-auto min-w-[18px] h-[18px] px-1 rounded-full bg-red-500 text-white text-[10px] font-bold grid place-items-center">{newsUnread > 99 ? "99+" : newsUnread}</span>}
                    {it.section === "consegne" && consegneUnread > 0 && <span data-testid="nav-badge-consegne" title="Consegne da leggere oggi" className="ml-auto min-w-[18px] h-[18px] px-1 rounded-full bg-red-500 text-white text-[10px] font-bold grid place-items-center">{consegneUnread > 99 ? "99+" : consegneUnread}</span>}
                    {it.to === "/operatori" && badges.operatori > 0 && <span data-testid="nav-badge-operatori" title="Contratti operatori in scadenza (entro 30 giorni)" className="ml-auto min-w-[18px] h-[18px] px-1 rounded-full bg-amber-500 text-white text-[10px] font-bold grid place-items-center">{badges.operatori > 99 ? "99+" : badges.operatori}</span>}
                    {it.section === "comunicazioni" && chatUnread > 0 && <span data-testid="nav-badge-comunicazioni" title="Messaggi non letti" className="ml-auto min-w-[18px] h-[18px] px-1 rounded-full bg-red-500 text-white text-[10px] font-bold grid place-items-center">{chatUnread > 99 ? "99+" : chatUnread}</span>}
                  </NavLink>
                ))}
              </div>
            );
          })}
        </nav>
      </aside>

      <div className="flex-1 flex flex-col min-w-0 h-[100dvh] overflow-hidden">
        <header className="h-16 bg-white border-b flex items-center gap-3 md:gap-4 px-4 md:px-6 sticky top-0 z-20">
          <button onClick={() => setMobileOpen(true)} className="md:hidden -ml-1 p-2 rounded-lg hover:bg-muted text-foreground" data-testid="sidebar-toggle" aria-label="Apri menu"><Menu size={22} /></button>
          <button onClick={() => setCollapsed((c) => !c)} className="hidden md:inline-flex -ml-1 p-2 rounded-lg hover:bg-muted text-foreground" data-testid="sidebar-collapse-toggle" aria-label={collapsed ? "Apri menu" : "Chiudi menu"} title={collapsed ? "Apri menu" : "Chiudi menu"}><PanelLeft size={22} /></button>
          <div className="flex items-center gap-2 min-w-0">
            <span className="text-sm text-muted-foreground font-semibold hidden xl:block">Struttura:</span>
            <div className="hidden xl:flex items-center gap-1.5 overflow-x-auto" data-testid="structure-buttons">
              {structures.length > 1 && (
                <button onClick={() => setSelectedStructure("all")} data-testid="struct-btn-all"
                  className={`shrink-0 h-9 px-3 rounded-full text-sm font-bold border transition-colors ${selectedStructure === "all" ? "bg-primary text-white border-primary" : "bg-white hover:bg-secondary border-border text-foreground"}`}>Tutte</button>
              )}
              {structures.map((s) => (
                <button key={s.id} onClick={() => setSelectedStructure(s.id)} data-testid={`struct-btn-${s.id}`}
                  className={`shrink-0 h-9 px-3 rounded-full text-sm font-bold border transition-colors ${selectedStructure === s.id ? "bg-primary text-white border-primary shadow-sm" : "bg-white hover:bg-secondary border-border text-foreground"}`}>{s.nome}</button>
              ))}
            </div>
            <div className="xl:hidden">
              <Select value={selectedStructure} onValueChange={setSelectedStructure}>
                <SelectTrigger className="w-[150px] font-semibold" data-testid="structure-selector">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  {structures.length > 1 && <SelectItem value="all" data-testid="struct-all">Tutte</SelectItem>}
                  {structures.map((s) => (
                    <SelectItem key={s.id} value={s.id} data-testid={`struct-${s.id}`}>{s.nome}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
          </div>
          <div className="ml-auto flex items-center gap-2.5 md:gap-3 min-w-0">
            <HelpButton />
            {firmaEnabled && activeOperatore && <IdleBar />}
            {firmaEnabled && activeOperatore && (
              <div className="hidden sm:flex items-center gap-2 pl-2.5 pr-1.5 py-1 rounded-full bg-emerald-50 border border-emerald-200 min-w-0 mr-0.5" data-testid="firma-indicator">
                <UserCircle size={18} className="text-emerald-700 shrink-0" />
                <span className="text-sm font-bold text-emerald-800 truncate">Operatore: {shortName(activeOperatore)}</span>
                <button onClick={change} data-testid="firma-cambia" className="ml-1 text-xs font-bold px-2.5 py-1.5 rounded-full bg-emerald-600 text-white hover:bg-emerald-700 transition-colors shrink-0">Cambia</button>
              </div>
            )}
            {firmaEnabled && activeOperatore && (
              <div className="sm:hidden flex items-center gap-1 pl-2 pr-1 py-0.5 rounded-full bg-emerald-50 border border-emerald-200 min-w-0" data-testid="firma-indicator-m">
                <span className="text-xs font-bold text-emerald-800 truncate max-w-[52px]">{shortName(activeOperatore)}</span>
                <button onClick={change} data-testid="firma-cambia-m" title="Cambia operatore" aria-label="Cambia operatore" className="h-8 w-8 grid place-items-center rounded-full bg-emerald-600 text-white shrink-0"><RefreshCw size={14} /></button>
              </div>
            )}
            {(() => { const it = MENU.flatMap((g) => g.items).find((i) => i.to === location.pathname); return <StoricoModificheBtn key={location.pathname} path={location.pathname} sezione={it?.section} titolo={it?.label} />; })()}
            <button className="relative p-2.5 rounded-lg hover:bg-secondary shrink-0" onClick={() => nav(bellDest2)} title={bellTitle2} data-testid="header-notifications">
              <Bell size={20} />
              {bellTotal2 > 0 && <span className="absolute top-0 right-0 min-w-[17px] h-[17px] px-1 rounded-full bg-red-600 text-white text-[10px] font-bold grid place-items-center animate-pulse" data-testid="notif-badge">{bellTotal2 > 99 ? "99+" : bellTotal2}</span>}
            </button>
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <button className="flex items-center gap-2 p-1.5 pr-2 rounded-lg hover:bg-secondary shrink-0" data-testid="user-menu">
                  <UserCircle size={26} className="text-primary" />
                  <div className="text-left hidden sm:block">
                    <div className="text-sm font-bold leading-tight">{user?.name}</div>
                    <div className="text-xs text-muted-foreground capitalize">{user?.role?.replace("_", " ")}</div>
                  </div>
                  <ChevronDown size={16} />
                </button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" className="w-52">
                <DropdownMenuLabel>{user?.email}</DropdownMenuLabel>
                <DropdownMenuSeparator />
                <DropdownMenuItem onClick={() => { logout(); nav("/login"); }} data-testid="logout-btn">
                  <LogOutIcon size={16} className="mr-2" /> Esci
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          </div>
        </header>
        <main className={`flex-1 min-h-0 overflow-y-auto overscroll-contain p-4 md:p-6 ${location.pathname.startsWith("/cartella-clinica") || location.pathname.startsWith("/impostazione-terapie") ? "max-w-none md:px-3" : "max-w-[1500px]"} w-full pb-[calc(4.5rem+env(safe-area-inset-bottom))] md:pb-6`}><OspiteFocus />{children}</main>
      </div>
      <NewsPopup />
      <SollecitoPopup />
      <FineTurnoPopup />

      {/* Barra di navigazione inferiore — solo smartphone (pollice in basso) */}
      <nav className="gr-bottombar md:hidden fixed bottom-0 left-0 right-0 z-40 flex items-stretch border-t border-white/10" style={{ background: "var(--gr-sidebar)" }} data-testid="bottom-nav">
        {[
          { to: "/", label: "Dashboard", icon: LayoutDashboard, testid: "dashboard" },
          { to: "/supervisor-ospiti", label: "Report", icon: ClipboardCheck, testid: "report-giorno", badge: reportDaCompletare, badgeCls: "bg-orange-500" },
          { to: "/presenze", label: "Presenze", icon: Clock, testid: "presenze" },
          { to: "/consegne", label: "Consegne", icon: ClipboardList, testid: "consegne", badge: consegneUnread },
          { to: "/ospiti", label: "Ospiti", icon: Users, testid: "ospiti" },
        ].map((it) => {
          const active = it.to === "/" ? location.pathname === "/" : location.pathname.startsWith(it.to);
          return (
            <NavLink key={it.to} to={it.to} data-testid={`bottom-nav-${it.testid}`}
              className={`gr-bottom-link relative flex-1 flex flex-col items-center justify-center gap-0.5 min-h-[52px] pt-1.5 text-[11px] font-semibold transition-colors ${active ? "text-white" : "text-[#8fb0a4]"}`}>
              <span className={`grid place-items-center h-7 w-12 rounded-full transition-colors ${active ? "bg-[color:var(--gr-sidebar-active)]" : ""}`}>
                <it.icon size={20} style={active ? undefined : { color: iconColor(it, "Area operativa") }} />
                {it.badge > 0 && <span data-testid={`bottom-nav-badge-${it.testid}`} className={`absolute top-1 right-[22%] min-w-[16px] h-[16px] px-1 rounded-full ${it.badgeCls || "bg-red-500"} text-white text-[9px] font-bold grid place-items-center`}>{it.badge > 9 ? "9+" : it.badge}</span>}
              </span>
              <span className="leading-none">{it.label}</span>
            </NavLink>
          );
        })}
      </nav>
    </div>
  );
}
